import { supabase } from './api'

export const revalidate = 0

function getCompanyId() {
	return localStorage.getItem('companyId')
}

export async function getAllData() {
	const { data, error } = await supabase.from('profiles').select()

	if (error) {
		throw new Error('Failed to fetch data')
	}
	return data
}

export async function getDataWithType(type) {
	const { data, error } = await supabase.from('profiles').select().eq('type', type)

	if (error) {
		throw new Error('Failed to fetch data')
	}
	return data
}

export async function getIdData(id) {
	const { data, error } = await supabase.from('profiles').select().eq('id', id)
	if (error) {
		throw new Error('Failed to fetch data')
	}
	return data
}

export async function addData(adata) {
	const companyId = getCompanyId()
	adata = { ...adata, companyId: companyId }

	const { data, error } = await supabase.from('profiles').insert(adata).select()

	if (error) {
		throw new Error('Failed to add data')
	}
	return data
}

export async function updateData(udata) {
	const { data, error } = await supabase.from('profiles').update(udata).eq('id', udata.id).select()

	if (error) {
		throw new Error('Failed to update data')
	}
	return data
}

export async function deleteIdData(id) {
	const { data, error } = await supabase.from('profiles').delete().eq('id', id)
	if (error) {
		throw new Error('Failed to delete data')
	}
	return data
}
